import React, { Fragment, useState } from "react";
import { Button, Form, Grid } from "semantic-ui-react";
import { Tag } from "antd";
/**
 * @author
 * @function FormMessage
 **/

const FormMessage = ({onTextSend}) => {
    const [input,setInput] = useState("")

    const triggerSend = () => {
        onTextSend(input);
        setInput('')
    }
  return (
    <Fragment>
      <div style={{ display: "flex", padding: "7px", overflowX: "auto" }}>
        <Tag>!help</Tag>
        <Tag color ="green" onClick = {() => setInput("!resume")}>!resume</Tag>
        <Tag>!about</Tag>
        <Tag>!activity</Tag>
      </div>
      <Grid columns={2} style={{ margin: "0px", padding: "0px" }}>
        <Grid.Row>
          <Grid.Column width={12}>
            <Form style={{ margin: "0px", padding: "0px" }}>
              <Form.Field>
                <input
                value = {input}
                onChange = {(e) => setInput(e.target.value)}
                  style={{ borderRadius: "15px" }}
                  placeholder="Try typing !resume"
                />
              </Form.Field>
            </Form>
          </Grid.Column>
          <Grid.Column width={2}>
            <Button onClick = {() => triggerSend(input)}>Send</Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Fragment>
  );
};

export default FormMessage;
